export const NE_PREMIUM_DELIVERY_OPTIONS: string[] = [
  'ne-envia-fedex-ground',
  'ne-envia-fedex-express',
  'ne-envia-dhl-ground',
  'ne-envia-dhl-express',
  'ne-envia-noventa9Minutos-local-next-day',
  'ne-envia-noventa9Minutos-next-day',
  'ne-envia-fedex-int-ground',
  'ne-envia-dhl-int-express',
];
